import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  UpdateSettingsPage,
  getSettingsListAll,
} from "../../../redux/settings/action";
import { useFormik } from "formik";
import Spinner from "../../Layouts/Spinner";
import { WebHookUrlSigned } from "../../Constant/constant";

const WebHookUrl = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const settingsListData = useSelector(
    (state) => state?.reusableSlice?.settingsListData
  );

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      sign_webhook_url: settingsListData?.sign_webhook_url,
    },
    validationSchema: WebHookUrlSigned,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = async (values) => {
    const data = {
      ...values,
      id: settingsListData?.id,
    };
    dispatch(UpdateSettingsPage(data, setLoading));
  };

  useEffect(() => {
    dispatch(getSettingsListAll());
  }, [dispatch]);

  return (
    <div className="">
      <h3 className="pb-3">Sign webhook url</h3>
      <form onSubmit={formik.handleSubmit}>
        <div className="row">
          <div className="form-group col-md-12">
            <label htmlFor="referral_duration_type">Sign webhook url</label>
            <input
              type="sign_webhook_url"
              className="form-control"
              placeholder="Enter sign webhook url"
              name="sign_webhook_url"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.sign_webhook_url}
            />
            {formik.touched.sign_webhook_url &&
            formik.errors.sign_webhook_url ? (
              <div className="error">{formik.errors.sign_webhook_url}</div>
            ) : null}
          </div>
        </div>
        <button
          className="submit-btn d-block mx-auto mt-3  "
          style={{ width: "max-content" }}
          type="submit"
        >
          {!loading ? "Submit" : <Spinner />}
        </button>
      </form>
    </div>
  );
};

export default WebHookUrl;
